import keheLogo from "/img/integration/kehe.png"
import { ConnectIntegrationForm } from "../connect-integration-form"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function ConnectKehePage(props: any = {}) {
  const redirectTo: string = props.redirectTo ?? "/setup/connect/kehe-freshdesk"

  return (
    <ConnectIntegrationForm
      integrationName="kehe"
      redirectTo={redirectTo}
      logoSrc={keheLogo}
      logoAlt="KeHE"
      description="Enter your KeHE Connect credentials to sync your deduction data."
    />
  )
}
